export default "__VITE_ASSET__gGKTZF62__"